import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import { Calendar, MapPin, User2, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Competitions() {
  const navigate = useNavigate();
  const [comps, setComps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/competitions")
      .then((r) => setComps(r.data))
      .catch(() => toast.error("Impossibile caricare le competizioni"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="mb-10">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight">
            <span className="bg-gradient-to-r from-[#FF5722] to-[#00E5FF] bg-clip-text text-transparent">
              Competizioni attive
            </span>
          </h1>
          <p className="text-white/60 mt-3 max-w-2xl">
            Seleziona la competizione per cui vuoi inviare la tua Musica o il tuo Video.
          </p>
        </div>

        {loading && (
          <div className="flex items-center gap-2 text-white/60">
            <Loader2 className="w-5 h-5 animate-spin" /> Caricamento...
          </div>
        )}

        {!loading && comps.length === 0 && (
          <div
            data-testid="no-competitions"
            className="bg-white/5 border border-white/10 rounded-2xl p-10 text-center text-white/70"
          >
            Nessuna competizione attiva al momento.
            <div className="text-xs text-white/40 mt-2">
              Torna più tardi o contatta l'organizzazione.
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {comps.map((c) => (
            <button
              key={c.id}
              data-testid={`competition-card-${c.id}`}
              onClick={() => navigate(`/competizioni/${c.id}`)}
              className="group relative text-left bg-[#0E0E11] rounded-2xl p-6 overflow-hidden border border-white/10 hover:border-white/20 transition-all hover:-translate-y-1"
              style={{
                boxShadow: `0 0 0 1px ${c.border_color}33, 0 18px 40px -20px ${c.border_color}55`,
                borderTop: `4px solid ${c.border_color}`,
              }}
            >
              <div
                className="absolute -top-20 -right-20 w-48 h-48 rounded-full opacity-20 blur-3xl group-hover:opacity-40 transition-opacity"
                style={{ background: c.border_color }}
              />
              <h3 className="font-bold text-xl mb-3 relative">{c.name}</h3>
              <div className="space-y-2 text-sm text-white/70 relative">
                <div className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" style={{ color: c.border_color }} />
                  <span>{c.location}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Calendar className="w-4 h-4" style={{ color: c.border_color }} />
                  <span>
                    {c.start_date}
                    {c.end_date !== c.start_date && ` → ${c.end_date}`}
                  </span>
                </div>
                {c.dj_names && c.dj_names.length > 0 && (
                  <div className="flex items-start gap-2">
                    <User2 className="w-4 h-4 mt-0.5" style={{ color: c.border_color }} />
                    <span className="text-xs">DJ: {c.dj_names.join(", ")}</span>
                  </div>
                )}
              </div>
              <div className="mt-5 flex items-center gap-2 text-sm font-semibold relative" style={{ color: c.border_color }}>
                <span>Procedi</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
